import { isWebViewUserAgent, isIosUserAgent, isAndroidUserAgent, } from '@fourthwall/webview-bridge/utils';
export const isWebView = () => isWebViewUserAgent(window.navigator.userAgent);
export const isIos = () => isIosUserAgent(window.navigator.userAgent);
export const isAndroid = () => isAndroidUserAgent(window.navigator.userAgent);
export const onWebViewModalOpen = () => {
    if (!isWebView())
        return;
    try {
        // @ts-ignore
        isIos() && window.webkit.messageHandlers.modalAppeared.postMessage(true);
        // @ts-ignore
        isAndroid() && window.Modal.modalAppeared();
    }
    catch (_a) {
        throw new Error('Calling window.webkit.messageHandlers.modalAppeared.postMessage or window.Modal.modalAppeared failed.');
    }
};
export const onWebViewModalClose = () => {
    if (!isWebView())
        return;
    try {
        // @ts-ignore
        isIos() && window.webkit.messageHandlers.modalDisappeared.postMessage(true);
        // @ts-ignore
        isAndroid() && window.Modal.modalDisappeared();
    }
    catch (_a) {
        throw new Error('Calling window.webkit.messageHandlers.modalDisappeared.postMessage or window.Modal.modalDisappeared failed.');
    }
};
